<template>
  <div>
    <va-card class="mb-4">
      <div class="d-flex justify--space-between align--center">
        <h1>{{ isEdit ? "Редактировать товар" : "Создать товар" }}</h1>
        <va-button color="gray" @click="goBack">Назад</va-button>
      </div>
    </va-card>
    <va-inner-loading :loading="loading">
      <va-card v-if="!isEdit || productInfo">
        <product-form
          :mode="isEdit ? 'edit' : 'create'"
          :product-info="productInfo"
          @close="goBack"
        />
      </va-card>
    </va-inner-loading>
  </div>
</template>

<script>
import Vue from "vue";
import api from "@/api/axios";
import { mapActions } from "vuex";
import ProductForm from "@/components/products/ProductForm.vue";

export default {
  name: "ProductFormPage",
  components: { ProductForm },
  data() {
    return {
      productInfo: null,
      loading: false,
    };
  },
  computed: {
    isEdit() {
      return Boolean(this.$route.params.slug);
    },
  },
  async created() {
    await this.loadMetaData();
    if (this.isEdit) {
      await this.loadProduct();
    }
  },
  methods: {
    ...mapActions({
      getProductData: "product/getProductData",
    }),
    async loadMetaData() {
      if (!this.isEdit) this.loading = true;
      try {
        await this.getProductData();
      } catch (error) {
        this.notifyError(
          "Ошибка загрузки метаданных",
          error.message || "Не удалось загрузить данные"
        );
      } finally {
        if (!this.isEdit) this.loading = false;
      }
    },
    async loadProduct() {
      this.loading = true;
      try {
        const { data } = await api.get(
          `/admin/products/${this.$route.params.slug}`
        );
        this.productInfo = data.data || data;
      } catch (error) {
        this.notifyError(
          "Ошибка загрузки товара",
          error.message || "Не удалось загрузить товар"
        );
      } finally {
        this.loading = false;
      }
    },
    notifyError(title, message) {
      const payload = { type: "error", title, text: message, message };
      (this.$notify || Vue.notify)(payload);
    },
    goBack() {
      this.$router.push("/admin/products");
    },
  },
};
</script>
